import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { useTranslation } from 'react-i18next';

// Container for the whole section
const Section = styled.div`
  ${tw`flex flex-col md:flex-row rounded-none overflow-hidden bg-[#336734]`}
  width: 100vw;
  min-width: 100vw;
  margin-left: calc(-50vw + 50%);
  margin-right: calc(-50vw + 50%);
  min-height: 220px;
`;

// Image container
const ImageContainer = styled.div`
  ${tw`w-full md:w-1/2 flex items-center justify-center`}
  background: #e3d6c8;
  min-height: 220px;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
`;

// Content container
const Content = styled.div`
  ${tw`w-full md:w-1/2 flex flex-col justify-center items-center p-8`}
  background: #5d655a;
  text-align: center;
`;

// Title
const Title = styled.h2`
  ${tw`text-xl md:text-2xl font-bold mb-4`}
  color: #FFF;
`;

// Description
const Description = styled.p`
  ${tw`mb-6`}
  font-size: 1rem;
  color: #FFF;
`;

// Outlined Button
const OutlinedButton = styled.button`
  ${tw`px-6 py-2 rounded border border-gray-700 font-medium`}
  background: #336734;
  color: #FFFF;
  transition: background 0.2s, color 0.2s;
  &:hover {
    background: #336734;
    color: #fff;
  }
`;

const ForceOfNatureSection = ({ imageSrc, onButtonClick }) => {
  const { t } = useTranslation();
const { i18n } = useTranslation();
  return (
    <Section>
      <ImageContainer>
        <img src={imageSrc} alt={t("title_force_of_nature")} />
      </ImageContainer>
      <Content>
        <Title>{t("title_force_of_nature")}</Title>
        <Description>{t("description_force_of_nature")}</Description>
        <OutlinedButton onClick={onButtonClick}>
          {t("button_force_of_nature")}
        </OutlinedButton>
      </Content>
    </Section>
  );
};

export default ForceOfNatureSection;
